import React from 'react';
import { SegmentedControl } from '@mantine/core';
import { useDevice } from '../../hooks/useDevice';
import { CardSize } from '../../types';

interface CardSizeControlProps {
  value: CardSize;
  onChange: (value: CardSize) => void;
  style?: React.CSSProperties;
}

export const CardSizeControl: React.FC<CardSizeControlProps> = ({ value, onChange, style }) => {
  const deviceType = useDevice();

  return (
    <SegmentedControl
      value={value}
      onChange={(value) => onChange(value as 'S' | 'M' | 'L')}
      data={[
        { label: 'S', value: 'S' },
        { label: 'M', value: 'M' },
        { label: 'L', value: 'L' },
      ]}
      size={deviceType === 'mobile' ? 'xs' : 'sm'}
      orientation={deviceType === 'mobile' ? 'vertical' : 'horizontal'}
      style={style}
    />
  );
};
